import { EmptyState } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/components/EmptyState.tsx";
import { Link } from "@tanstack/react-router";
import SearchX from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/search-x.mjs";
import { useTranslation } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/react-i18next@17.1.8_i18next@26.5.10_typescript@6.0.3__react-dom@18.3.1_react@18.3.1__react@18.3.1_typescript@6.0.3/node_modules/react-i18next/dist/es/useTranslation.js";

import { PageHeading } from "./PageHeading";

export type AreaHome = "/" | "/app" | "/portal" | "/app/admin";

export interface NotFoundProps {
  /** Where "Volver al inicio" goes: the area home (FR-FE01-06). */
  home?: AreaHome;
  /** Inside an area shell, which already renders `<main>`. */
  inShell?: boolean;
}

/** Not-found state per area (FE-01 FR-FE01-06): translated message and a link to the area home. */
export function NotFound({ home = "/", inShell = false }: NotFoundProps) {
  const { t } = useTranslation();
  const body = (
    <>
      <PageHeading title={t("notFound.title")} className="sr-only">
        {t("notFound.title")}
      </PageHeading>
      <EmptyState
        icon={SearchX}
        title={t("notFound.title")}
        body={t("notFound.body")}
        action={
          <Link
            to={home}
            className="inline-flex min-h-12 items-center font-semibold text-primary underline"
          >
            {t("notFound.back")}
          </Link>
        }
      />
    </>
  );
  if (inShell) return <div className="mx-auto max-w-[560px] p-4">{body}</div>;
  return (
    <main id="main" className="mx-auto max-w-[560px] p-4">
      {body}
    </main>
  );
}

export const RootNotFound = () => <NotFound />;
export const SellerNotFound = () => <NotFound home="/app" inShell />;
export const OwnerNotFound = () => <NotFound home="/portal" inShell />;
export const AdminNotFound = () => <NotFound home="/app/admin" inShell />;
